import { Injectable } from '@angular/core';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { PageSize } from 'src/app/common/GridPageSize';
@Injectable({
  providedIn: 'root'
})

export class CommonPageService {

  commonState: State = {
    skip: 0,
    take: PageSize.Size,
    sort: [],
    filter: null,
  };
  
  groupPaginationListDataCommon: GridDataResult;
  public clearGroupPaginationListDataCommon() {
    this.groupPaginationListDataCommon = {
      data: [],
      total: 0
    }
  }

  public setGroupPaginationListDataCommon(data: any, total: number) {
    this.groupPaginationListDataCommon = {
      data: data,
      total: total
    }
  }

  public clearCommonState() {
    this.commonState = {
      skip: 0,
      take: PageSize.Size,
      sort: [],
      filter: null,
    };
  }

  public getCustomPageModel(
    statusId: number = 0, 
    facilityId: number = 0, 
    priorityId: number = 0, 
    thirdPartyId: number = 0, 
    isRecon: number = 0, 
    departmentId: number = 0, 
    documentTypeId: number = 0,
    patientId: number = 0,
    requestId: number = 0,
    dumpId: number = 0,
    vobId: number = 0,
    fromDate: Date = null,
    toDate: Date = null,
    facilityIds: string = '',
    cardId: number = 0,
    authId: number = 0,
   ): any {
    return {
      departmentId: departmentId,
      documentTypeId: documentTypeId,
      facilityId: facilityId,
      statusId: statusId,
      priorityId: priorityId,
      thirdPartyId: thirdPartyId,
      isRecon: isRecon,
      patientId: patientId,
      requestId: requestId,
      dumpId: dumpId,
      vobId: vobId,
      fromDate: fromDate,
      toDate: toDate,
      facilityIds: facilityIds,
      cardId: cardId,
      authId: authId,
      state: {
        skip: this.commonState.skip,
        take: this.commonState.take,
        sort: this.commonState.sort,
        filter: this.commonState.filter != null ? this.commonState.filter?.filters : [],
      }
    }
  }


  public getReportsCustomPageModel(
    facilityName: string = '',
    practiceName: string = '',
    carrierName: string = '',
    locName: string = '',
    searchText: string = '',
    fromDate: Date = null,
    toDate: Date = null,
    subReportType: number = 0,
   ): any {
    return {
      facilityName: facilityName,
      practiceName: practiceName,
      carrierName: carrierName,
      locName: locName,
      searchText: searchText,
      fromDate: fromDate,
      toDate: toDate,
      subReportType: subReportType,
      state: {
        skip: this.commonState.skip,
        take: this.commonState.take,
        sort: this.commonState.sort,
        filter: this.commonState.filter != null ? this.commonState.filter?.filters : [],
      }
    }
  }

  public getUserCustomPageModel(
    userFullName: string = '',
    userName: string = '',
    userSource: string = '',
    userRole: string = '',
    userFacility: string = '',
    userStatus: string = '',
    lastLogin: string = ''
  ): any {
    return {
      userFullName: userFullName,
      userName: userName,
      userSource: userSource,
      userRole: userRole,
      userFacility: userFacility,
      userStatus: userStatus,
      lastLogin: lastLogin,
      state: {
        skip: this.commonState.skip,
        take: this.commonState.take,
        sort: this.commonState.sort,
        filter: this.commonState.filter != null ? this.commonState.filter?.filters : [],
      }
    }
  }

  public exportToPDF(gridComponent: GridComponent): void {
    gridComponent.saveAsPDF();
  }
  
  public exportToExcel(gridComponent: GridComponent): void {
    gridComponent.saveAsExcel();
  }
}
